import { render, staticRenderFns } from "./sms.vue?vue&type=template&id=cbef74dc&"
import script from "./sms.vue?vue&type=script&lang=js&"
export * from "./sms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports